import { createEvent } from "library/local-events/index.mjs"
export const RefiningTypes = createEvent("RefiningTypes")
export const RegisterTypeProgress = createEvent("RegisterTypeProgress")
// Broadcast (server -> all clients) when a system flag changes, so the app-wide HubSpot
// banner and any open admin tabs invalidate their cached flag queries without a reload.
export const SystemFlagsChanged = createEvent("SystemFlagsChanged")
